import { useEffect, useState } from "react";
import "./StayUpToDateComponentsWrapper.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Modal, Button } from "antd";
import {
  deleteComponent,
  updateIndexValue,
} from "../../../../Utils/SupabaseServices/StayUpToDateDatabase";
import StayUpToDateSkeleton from "./StayUpToDateSkeleton";
import SubComponentsWrapper from "../../LandingPageCarousels/SubComponentsWrapper/SubComponentsWrapper";
import ComponentDeleteModal from "../../../../components/DeleteModal/ComponentDeleteModal";

const ITEMS_PER_PAGE = 5;
const ITEMS_PER_PAGE_MAXIMIZED = 20;
const ArchivedComponentsWrapper = (props: any) => {
  const {
    username,
    user_id,
    StayUpToDateComponents,
    StayUpToDateComponentsLoading,
    refetch,
    brand_color,
    refatchStayUpToDate,
    from,
    isMaximized,
  } = props;
  const [localData, setLocalData] = useState(StayUpToDateComponents);
  const [displayedItems, setDisplayedItems] = useState(
    isMaximized ? ITEMS_PER_PAGE_MAXIMIZED : ITEMS_PER_PAGE
  );

  const [selectedComponent, setSelectedComponent] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [status, setStatus] = useState("");

  useEffect(() => {
    setLocalData(StayUpToDateComponents);
  }, [StayUpToDateComponents, status]);
  useEffect(() => {
    setDisplayedItems(isMaximized ? ITEMS_PER_PAGE_MAXIMIZED : ITEMS_PER_PAGE);
  }, [isMaximized]);

  useEffect(() => {
    refetch();
  }, [status, StayUpToDateComponents]);
  const cleanupDraggingState = () => {
    const allDraggingElements = document.querySelectorAll(".dragging");
    allDraggingElements.forEach((element) => {
      element.classList.remove("dragging");
    });

    const allRbdDraggingElements = document.querySelectorAll(
      "[data-rbd-dragging='true']"
    );
    allRbdDraggingElements.forEach((element) => {
      element.removeAttribute("data-rbd-dragging");
    });

    document.documentElement.style.scrollBehavior = "";
    document.body.style.scrollBehavior = "";
  };
  useEffect(() => {
    const handleClick = () => {
      const draggingElements = document.querySelectorAll(".dragging");
      const rbdDraggingElements = document.querySelectorAll(
        "[data-rbd-dragging='true']"
      );
      if (draggingElements.length > 0 || rbdDraggingElements.length > 0) {
        cleanupDraggingState();
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }
    const newData = [...localData];

    const [removed] = newData.splice(result.source.index, 1);

    newData.splice(result.destination.index, 0, removed);
    setLocalData([...newData]);
    updateIndexValue(user_id, newData);
  };

  const loadMore = () => {
    setDisplayedItems((prev) =>
      Math.min(
        prev + (isMaximized ? ITEMS_PER_PAGE_MAXIMIZED : ITEMS_PER_PAGE),
        localData.length
      )
    );
  };

  async function handleDelete(name: any) {
    setSelectedComponent(name);
    setOpenDeleteModal(true);
  }

  return (
    <div className="stay-up-to-date-wrapper">
      {StayUpToDateComponentsLoading ? (
        <div className="loader-container">
          <div className="component-box">
            <StayUpToDateSkeleton />
          </div>
        </div>
      ) : (
        <>
          <DragDropContext
            onDragStart={(start) => {
              document.documentElement.style.scrollBehavior = "unset";
              document.body.style.scrollBehavior = "unset";
              const existingDraggingElements = document.querySelectorAll(".dragging");
              existingDraggingElements.forEach((element) => {
                element.classList.remove("dragging");
              });
              
              const draggedElement = document.querySelector(
                `[data-rbd-draggable-id="${start.draggableId}"]`
              );
              draggedElement?.classList.add("dragging");
            }}
            onDragEnd={(result) => {
              // Restore scroll behavior
              document.documentElement.style.scrollBehavior = "";
              document.body.style.scrollBehavior = "";
              
              // Remove dragging class from all elements
              const allDraggingElements = document.querySelectorAll(".dragging");
              allDraggingElements.forEach((element) => {
                element.classList.remove("dragging");
              });
              
              // Also remove react-beautiful-dnd's data-rbd-dragging attribute
              const allRbdDraggingElements = document.querySelectorAll("[data-rbd-dragging='true']");
              allRbdDraggingElements.forEach((element) => {
                element.removeAttribute("data-rbd-dragging");
              });
              
              // Reset any inline styles that react-beautiful-dnd might have added
              const allDraggableElements = document.querySelectorAll("[data-rbd-draggable-id]");
              allDraggableElements.forEach((element) => {
                const el = element as HTMLElement;
                // Reset transform, transition, and z-index
                el.style.transform = "";
                el.style.transition = "";
                el.style.zIndex = "";
                el.style.position = "";
                el.style.top = "";
                el.style.left = "";
                el.style.width = "";
                el.style.height = "";
                
                // Add reset class to force visual reset
                el.classList.add("drag-reset");
                // Remove reset class after a short delay
                setTimeout(() => {
                  el.classList.remove("drag-reset");
                }, 50);
              });
              
              // Force a reflow
              void document.body.offsetHeight;
              
          
              
              onDragEnd(result);
            }}
          >
            <Droppable
              droppableId="droppable"
              direction="vertical"
              type="column"
            >
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="droppable-container"
                  style={{
                    touchAction: "pan-y",
                    height: "100%",
                  }}
                >
                  {localData &&
                    localData
                      .slice(0, displayedItems)
                      .map((component: any, index: number) => (
                        <SubComponentsWrapper
                          key={component.id}
                          component={component}
                          index={index}
                          user_id={user_id}
                          username={username}
                          refetch={refetch}
                          brand_color={brand_color}
                          handleDelete={handleDelete}
                          refatchStayUpToDate={refatchStayUpToDate}
                          setStatus={setStatus}
                          selectedComponent={selectedComponent}
                          setSelectedComponent={setSelectedComponent}
                          isEdit={isEdit}
                          setIsEdit={setIsEdit}
                          isEditModalOpen={isEditModalOpen}
                          setIsEditModalOpen={setIsEditModalOpen}
                          from={from}
                          isMaximized={isMaximized}
                        />
                      ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {displayedItems < localData.length && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={loadMore}
                // type="primary"
                className="join-button"
                style={{ padding: "0.5rem 1.5rem" }}
              >
                <p className="join-button-text">See More</p>
              </Button>
            </div>
          )}
          <ComponentDeleteModal
            openDeleteModal={openDeleteModal}
            // handleOk={handleOk}
            // handleCancel={handleCancel}
            // confirmLoading={confirmLoading}
            selectedComponent={selectedComponent}
            user_id={user_id}
            refetch={refetch}
            username={username}
            localData={localData}
            setLocalData={setLocalData}
            setOpenDeleteModal={setOpenDeleteModal}
            displayedItems={displayedItems}
            setDisplayedItems={setDisplayedItems}
          />
        </>
      )}
    </div>
  );
};

export default ArchivedComponentsWrapper;
